export type EmbeddingProvider = "azure" | "ollama" | "junet";
export const availableEmbeddingProviders = ["azure", "ollama", "junet"] as const;

export const embeddingProviderMap: Record<EmbeddingProvider, {label: string; value: string; image: string;}> = {
    azure: {
        label: "Azure",
        value: "azure",
        image: "/assets/providers/azure.svg",
    },
    ollama: {
        label: "Ollama",
        value: "ollama",
        image: "/assets/providers/ollama.svg",
    },
    junet: {
        label: "Junet Core",
        value: "junet",
        image: "/favicon.png",
    },
}
